import React from "react";
import { CheckCircle2, Circle, Loader2, Star } from "lucide-react";

export const STAGE_LABELS = {
  readiness: "Budget & Readiness",
  touring: "Touring Prep",
  comparison: "Home Comparison",
  offer: "Offer Readiness",
};

export function statusColor(status) {
  if (status === "complete") return "text-status-complete";
  if (status === "in_progress") return "text-status-progress";
  return "text-muted-foreground";
}

export function StageIcon({ status, className = "h-5 w-5" }) {
  if (status === "complete") return <CheckCircle2 className={`${className} text-status-complete`} />;
  if (status === "in_progress") return <Loader2 className={`${className} text-status-progress`} />;
  return <Circle className={`${className} text-muted-foreground`} />;
}

export function PageLoader() {
  return (
    <div className="flex items-center justify-center py-24">
      <Loader2 className="h-7 w-7 animate-spin text-primary" />
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-muted-foreground mt-1 text-sm sm:text-base max-w-2xl">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function money(n) {
  if (n == null || n === "") return "—";
  return "$" + Number(n).toLocaleString();
}

export function Stars({ value = 0, size = "h-4 w-4" }) {
  return (
    <span className="inline-flex gap-0.5" data-testid="stars-display">
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`${size} ${n <= value ? "fill-amber-400 text-amber-400" : "text-muted-foreground/30"}`} />
      ))}
    </span>
  );
}
